var LineMessageRenderer = require('linemessagerenderer');
var BufferLogContainerView = require('bufferlogcontainerview');
var Message = require('message');
var FileInlineView = require('fileinlineview');
var RenderReasons = require('renderreasons');
var util = require('../../lib/util.es6');


var BufferLogView = BufferLogContainerView.extend({
    tagName: 'div',
    className: 'log',
    initialize: function (options, scroll) {
        BufferLogContainerView.prototype.initialize.apply(this, arguments);
        
        this.model.bind('remove', this.remove, this);
        this.model.bind('clear', this.clear, this);
        this.model.bind('rendered', this.rendered, this);
        this.listenTo(this.model.session.backend, 'connected', this.removeAllPendingRows);
        
        this.lineRenderer = new LineMessageRenderer(this.model);
        
        this.bottomSeenVisible = false;
        this.focusSeenVisible = false;
        this.messageBuffer = [];
        this.rendered = false;
    },
    events: $.extend({}, BufferLogContainerView.prototype.events, {}),
    getVisibleLineStrict: function (message) {
        var line = this.getLine(message);
        if (line.length && line.is(':visible')) {
            return line;
        }
    },
    getVisibleLine: function (message) {
        var line = this.getLine(message);
        if (line.length && !line.is(':visible')) {
            var group = line.closest('.joinPartGroup').prev('.groupedJoinPart');
            if (group.length) {
                line = group;
            }
            while (line && !line.is(':visible')) {
                line = line.prev();
            }
        }
        return line;
    },
    preRenderMessageData: function (message, reqid) {
        return _.map(this.lineRenderer.prerender(message), function (prerendered, i) {
            var user = this.model.getUser();
            var data = {
                bid: this.model.bid(),
                type: prerendered.type,
                eid: this.model.session.backend.ts()*1000,
                from: user.getName(),
                msg: prerendered.message,
                chan: this.model.getName(),
                name: this.model.getName(),
                cid: this.model.getCid(),
                self: true,
                hostmask: user.get('usermask'),
                ident_prefix: user.get('ident_prefix'),
                from_host: user.get('userhost'),
                from_name: user.get('user'),
                from_mode: user.getMode(),
                from_account: user.get('account'),
                from_realname: user.getRealname(),
                avatar: user.get('avatar'),
                avatar_url: user.get('avatar_url'),
                display_name: user.get('display_name'),
                bot_url: user.get('bot_url')
            };
            if (reqid) {
                data._pendingreqid = reqid;
            }
            return data;
        }, this);
    },
    // Only bound after render
    sayRequest: function (message, reqid, extraHtml) {
        if (!message) {
            return;
        }
        // Parse message to see how we should pre-render it
        var messages = _.map(this.preRenderMessageData(message, reqid), function (data) {
            var m = new Message(data, {
                buffer: this.model
            });
            m._previousMessage = this.model.messages.lastVisible();
            return m;
        }, this);
        if (messages.length) {
            var rows = this.lineRenderer.renderMessages(messages).flush();
            var els = this.append(rows);
            if (extraHtml) {
                els.last().find('.message').append(extraHtml);
                this.triggerImagesLoaded(extraHtml);
            }
            this.removeLastSeen();
            
            this.scroll.onChange(true);
        }
    },
    rewriteSayRequest: function (reqid, newMessage) {
        if (newMessage) {
            // Parse message to see how we should pre-render it
            var messages = _.map(this.preRenderMessageData(newMessage, reqid), function (data) {
                return new Message(data, {
                    buffer: this.model
                });
            }, this);

            var rows = this.lineRenderer.renderMessages(messages).flush();
            // Assume only a single row to rewrite
            var content = $(rows[0]).find('.content').html();
            var row = this.getPendingRow(reqid);
            row.find('.content').html(content);
        } else {
            this.removePendingRow(reqid);
        }

        this.scroll.onChange(true);
    },
    throttleMessage: function () {
        var lastIndex = this.model.messages.findLastIndex(function (m) {
            return m.isThrottlable();
        });
        if (lastIndex !== -1) {
            var msg = this.model.messages.at(lastIndex);
            msg.markAsThrottled();
            this.getLine(msg).addClass('throttled').highlightFlash();
        }
    },
    addErrorUpload: function (file, errorType, errorResponse) {
        var line = this.getLine(file.sentMessage);
        var fileView = new FileInlineView({model: file});
        
        fileView.once('finalise', function (retryPromise) {
            var options = {
                reqid: this.model.session.backend._getRequestId()
            };
            fileView.remove();
            this.model.trigger('finaliseFileFromPromise', retryPromise, fileView, options);
        }, this);

        fileView.renderLocalInlinePreview().done(_.bind(function (preview) {
            if (errorResponse && errorType != 'abort') {
                preview.find('.userError').text(RenderReasons.renderPostError(errorResponse, file.sentMessage));
            }
            var extraHtml = $('<span class="fileWrap error">').append($('<span class="file">').append(preview));
            fileView.setElement(extraHtml);

            line.find('.message').append(extraHtml);

            this.triggerImagesLoaded(extraHtml);

            this.scroll.onChange(true);
        }, this));
    },
    sayError: function (response, message) {
        var pending = this.getPendingRow(response._reqid);
        pending.find('.fileWrap .userError').text(RenderReasons.renderPostError(response, message));
        pending.addClass('pendingError');

        this.scroll.onChange(true);
    },
    getPendingRow: function (reqid) {
        return this.$('.pending_' + reqid);
    },
    markPendingRowAsError: function (reqid) {
        this.getPendingRow(reqid).addClass('pendingError');
    },
    unmarkErrorPendingRow: function (reqid) {
        this.getPendingRow(reqid).removeClass('pendingError');
    },
    removePendingRow: function (reqid) {
        this.getPendingRow(reqid).remove();
        this.model.trigger('removePending', reqid);
    },
    removeAllPendingRows: function () {
        this.$('.pending').remove();
        this.model.trigger('removeAllPending');
    },
    renderBottomSeen: function () {
        var rows = this.lineRenderer.renderBottomSeenDivider(this.model.getBottomSeen()).flush();
        this.removeBottomSeen();
        this.append(rows);
    },
    renderFocusSeen: function () {
        var rows = this.lineRenderer.renderFocusSeenDivider(this.model.focusSeen).flush();
        this.removeFocusSeen();
        this.append(rows);
    },
    showBottomSeen: function () {
        var bottomSeen = this.getBottomSeen();
        if (bottomSeen.length) {
            if (!this.bottomSeenVisible) {
                // Remove any other markers to avoid a dupe
                this.removeFocusSeen();
                this.removeLastSeen();
                bottomSeen.removeClass('hidden');
                this.bottomSeenVisible = true;
            }
            return !!this.model.getBottomSeen();
        }
    },
    showFocusSeen: function () {
        var focusSeen = this.getFocusSeen();
        if (focusSeen.length) {
            if (!this.focusSeenVisible) {
                // Remove any other markers to avoid a dupe
                this.removeBottomSeen();
                this.removeLastSeen();
                focusSeen.removeClass('hidden');
                this.focusSeenVisible = true;
            }
            return !!this.model.getFocusSeen();
        }
    },
    removeBottomSeen: function () {
        this.getBottomSeen().remove();
        this.bottomSeenVisible = false;
    },
    removeFocusSeen: function () {
        this.getFocusSeen().remove();
        this.focusSeenVisible = false;
    },
    getBottomSeen: function () {
        return this.$('.bottomSeen');
    },
    getFocusSeen: function () {
        return this.$('.focusSeen');
    },
    renderFetching: function (initial) {
        this.removeLoadMore();
        this.removeFetchFailed();
        var rows = this.lineRenderer.renderFetchingDivider(this.model.messages.first(), initial).flush();
        this.prepend(rows);
    },
    removeFetchingRow: function () {
        this.$('.fetch').remove();
    },
    removeBacklogDivider: function () {
        this.getBacklogDivider().remove();
    },
    removeFetchFailed: function () {
        this.$('.fetchFailed').remove();
    },
    renderFetchFailed: function (discontinuity) {
        if (!discontinuity) {
            this.removeFetchingRow();
        }
        
        this.renderLoadMore();
        
        var rows = this.lineRenderer.renderFetchFailedDivider(this.model.messages.first()).flush();
        this.prepend(rows);
    },
    clear: function () {
        this.scroll.clearFirstRendered();

        this.$el.empty();

        this.renderLoadMore();

        var rows = this.lineRenderer.flush();
        
        // Add rows to DOM
        this.prepend(rows);
    },
    rendered: function () {
        this.rendered = true;
    },
    isRendered: function () {
        return !!this.rendered;
    },
    removeBefore: function (message) {
        var line = this.getLine(message);
        if (line.length) {
            this.scroll.setFirstRendered(message);
            this.removeLoadMore();

            // Reset first date change divider
            if (message.hasSameDateAsPrevious()) {
                this.$('.dateChange:first').remove();
                this.lineRenderer.renderDateRow(message);
            }
            
            // Check if we're in a group and pick out the lines we want to
            // keep before removing the group
            var group = line.closest('.joinPartGroup');
            var messages;
            if (group.length) {
                messages = _.filter(_.map(group.find('.row'), function (r) {
                    var msg = this.scroll.getMessageForRow($(r));
                    if (msg && msg.id >= message.id) {
                        return msg;
                    }
                }, this), _.identity);
                
                // Remove previous lines and group
                group.prevAll().remove();
                group.remove();
            } else {
                // Remove previous lines
                line.prevAll().remove();
            }

            // Reset firstAuthor if needed
            if (line.is('.sameAuthor')) {
                line.addClass('firstAuthor');
                line.removeClass('sameAuthor');
            }

            this.renderLoadMore();

            this.lineRenderer.renderMessagesAtTop(messages);
            
            var rows = this.lineRenderer.flush();
            
            // Add rows to DOM
            this.prepend(rows);
        }
    },
    renderFetchedMessages: function (messages, prevEarliest, discontinuity) {
        if (prevEarliest) {
            this.removeBefore(this.model.getMessage(prevEarliest));
        }

        this.scroll.setFirstRendered(messages[0]);

        if (!discontinuity) {
            this.removeFetchingRow();
        }

        this.renderLoadMore();

        this.lineRenderer.renderMessagesAtTop(messages);
        
        if (prevEarliest) {
            var dividingMessage = this.model.getMessage(prevEarliest);
            if (dividingMessage) {
                var previous = dividingMessage.previousVisible();
                if (previous) {
                    // Reset firstAuthor if needed
                    if (dividingMessage.hasSameAuthor(previous)) {
                        var line = this.getLine(dividingMessage);
                        if (line.is('.firstAuthor')) {
                            line.addClass('sameAuthor');
                            line.removeClass('firstAuthor');
                        }
                    }
                    
                    // Remove previous date change divider
                    if (dividingMessage.hasSameDate(previous)) {
                        this.$('.dateChange:first').remove();
                    } else if (previous) {
                        this.lineRenderer.renderDateRow(dividingMessage);
                    }
                }
            }
            
            this.removeBacklogDivider();
            
            if (messages.length && !discontinuity) {
                this.lineRenderer.renderBacklogDivider(dividingMessage);
            }
        }
    },
    renderFetched: function (messages, prevEarliest, discontinuity) {
        this.renderFetchedMessages(messages, prevEarliest, discontinuity);
        var rows = this.lineRenderer.flush();
        if (prevEarliest) {
            this.initialPrepend(rows);
        } else {
            this.initialAppend(rows);
        }

        if (messages.length) {
            this.handleClientTagsAtTop(messages);

            if (prevEarliest && !discontinuity) {
                return this.getBacklogDivider();
            }
        }
    },
    getBacklogDivider: function () {
        return this.$('.backlogDivider');
    },
    // Only bound after render, this is for real time messages,
    // initial backlog and past backlog are handled on render and
    // in the fetched handler
    bufferMessage: function (message) {
        this.messageBuffer.push(message);
        if (this.messageBuffer.length > this.trimDetectThreshold) {
            this.messageBuffer = this.messageBuffer.slice(-this.trimThreshold);
            this.messageBufferTrim = this.messageBuffer[0];
        }
    },
    bufferFlushTimeout: 200,
    checkFlush: function () {
        if (!this.lastFlush || util.ts() - this.lastFlush > this.bufferFlushTimeout) {
            this.flushBuffer();
        } else {
            setTimeout(_.bind(this.checkFlush, this), this.bufferFlushTimeout);
        }
    },
    trimDetectThreshold: 350,
    trimThreshold: 200,
    checkTrim: function (end) {
        var firstRender = this.scroll.getFirstRendered();
        if (firstRender) {
            var trimmable = this.model.trimmableMessages(firstRender, end);
            if (
                trimmable.length > this.trimDetectThreshold &&
                (end || this.scroll.isScrolledToBottom())
            ) {
                // Trim extra backlog
                var threshHoldMessage = trimmable.slice(-this.trimThreshold)[0];
                if (this.model.isSelected()) {
                    var topMessage = this.scroll.getMessageAtTopOfScroll();
                    if (topMessage && topMessage.isBefore(threshHoldMessage)) {
                        // Selected and top message occurs above threshold
                        // trim from that instead
                        debug.log(this.model.getTitle(), 'top selected');
                        this.removeBefore(topMessage);
                    } else {
                        debug.log(this.model.getTitle(), 'threshold selected');
                        this.removeBefore(threshHoldMessage);
                    }
                } else {
                    debug.log(this.model.getTitle(), 'unselected');
                    this.removeBefore(threshHoldMessage);
                }
                debug.timeStamp(this.model.getTitle() + ' [trim]');
            }
        }
    },
    renderBelowScroll: function () {
        var bottomSeen = this.scroll.getMessageForRow(this.getBottomSeen());
        this.flushBuffer(bottomSeen);
    },
    removePending: function (message) {
        if (message.has('reqid')) {
            if (!message.get('entities') || !message.get('entities').files || !message.get('entities').files[0].url) {
                this.removePendingRow(message.get('reqid'));
            }
        } else if (this.model.isConversation() && this.model.isSelf()) {
            this.removeAllPendingRows();
        }
    },
    flushBuffer: function (bottomSeen) {
        this.lastFlush = util.ts();
        this.checkTrim(bottomSeen);
        if (!this.messageBuffer.length) {
            return;
        }
        var batchOptions = this.batchOptions();

        this.scroll.checkPinBottom(function (pinBottom) {
            if (!bottomSeen && !pinBottom) {
                // Only render client tags if scrolled up
                // Filter successfully processed messages out of the buffer
                this.messageBuffer = _.filter(this.messageBuffer, function (message) {
                    if (this.handleClientTags(message, batchOptions)) {
                        this.removePending(message);
                        return false;
                    } else {
                        return true;
                    }
                }, this);
                this.processBatched(batchOptions);
                this.scroll.onChange();
                return;
            }
            this.batchRendering = true;
            if (this.messageBufferTrim) {
                this.removeBefore(this.messageBufferTrim);
                delete this.messageBufferTrim;
            }
            var els = $();
            _.each(this.messageBuffer, function renderMessagesEach (message) {
                this.removePending(message);
                var batchEls = this.renderMessage(message, batchOptions);
                if (batchEls) {
                    var lastMessageRow = batchEls.closest('.messageRow').last();
                    var lastJoinPartHeading = batchEls.closest('.groupedJoinPart').last();
                    var lastDiscoHeading = batchEls.closest('.groupedDisco').last();
                    if (lastMessageRow.length) {
                        batchOptions.lastMessageRow = lastMessageRow;
                    }
                    if (lastJoinPartHeading.length) {
                        batchOptions.lastJoinPartHeading = lastJoinPartHeading;
                    }
                    if (lastDiscoHeading.length) {
                        batchOptions.lastDiscoHeading = lastDiscoHeading;
                    }

                    if (message.get('reqid')) {
                        if (batchOptions.reqidMap[message.get('reqid')]) {
                            batchEls = batchOptions.reqidMap[message.get('reqid')].add(batchEls);
                        }
                        batchOptions.reqidMap[message.get('reqid')] = batchEls;
                    } else {
                        batchOptions.nonReqidEls = batchOptions.nonReqidEls.add(batchEls);
                    }
                    els = els.add(batchEls);
                }
            }, this);
            els = els.not(batchOptions.toExclude);
            if (els.length) {
                this.batchAppend(els);
            }
            delete this.batchRendering;

            _.each(this.messageBuffer, function (message) {
                this.handleClientTags(message, batchOptions);
            }, this);

            this.processBatched(batchOptions);

            this.messageBuffer = [];
            this.scroll.onChange(pinBottom);
        }, this);
    },
    processBatched: function (options) {
        options.toRemove.remove();

        var replaceEls = _.reduce(options.toReplace, function (memo, els, key, obj) {
            return memo.add(els);
        }, $());
        this.prepareEmbeds(replaceEls);

        _.each(options.toReplace, function (replacement, messageId) {
            var row = this.getMsgIdRow(messageId);
            if (row.length) {
                this.doReplaceRow(row, replacement, messageId);
            }
        }, this);
        
        _.each(options.reqidMap, function (reqidEls, reqid) {
            this.postInsertion(reqidEls.not(options.toExclude), false, reqid);
        }, this);
        this.postInsertion(options.nonReqidEls.not(options.toExclude));
    },
    batchOptions: function () {
        return {
            batch: true,
            toExclude: $(),
            toRemove: $(),
            toReplace: {},
            nonReqidEls: $(),
            reqidMap: {}
        };
    },
    handleClientTagsAtTop: function (messages) {
        var batchOptions = this.batchOptions();

        _.each(messages, function (message) {
            this.handleClientTags(message, batchOptions);
        }, this);

        // Then check for any missing targets
        var missingReplyTargets = this.missingReplyTargets;
        this.missingReplyTargets = [];
        while (missingReplyTargets.length) {
            this.handleClientTags(missingReplyTargets.shift(), batchOptions);
        }

        this.processBatched(batchOptions);
    },
    renderMessage: function (message, options) {
        if (!this.scroll.getFirstRendered()) {
            if (!message.isEmpty()) {
                this.scroll.setFirstRendered(message);
                if (!this.scroll.isFetching()) {
                    this.removeLoadMore();
                    this.renderLoadMore();
                }
            }
        }
        if (message.equals(this.model.discontinuity)) {
            this.scroll.loadDiscontinuity();
        } else {
            var els = BufferLogContainerView.prototype.renderMessage.apply(this, arguments);
            if (!options || !options.batch) {
                this.handleClientTags(message, options);
            }
            if (els.length) {
                // Only show marker if not ignored and not a hidden join/part
                // (server logs don't have the isShowingJoinPart method)
                if (message.isSelf()) {
                    this.removeLastSeen();
                } else if (!message.isIgnored() &&
                    (this.model.isServerLog() || !message.isJoinPart() || this.model.isShowingJoinPart())
                ) {
                    this.showSeenMarker();
                }
                
                return els;
            }
        }
    },
    showSeenMarker: function () {
        // Show markers, but avoid dupes
        var bottom = this.showBottomSeen();
        if (!bottom) {
            var focus = this.showFocusSeen();
            if (!focus) {
                this.showLastSeen();
            }
        }
    },
    handleMessage: function (message) {
        this.bufferMessage(message);
        if (this.model.connection.isBacklogLoaded()) {
            this.checkFlush();
        }
    },
    renderLastSeen: function () {
        var lastSeen = this.model.getLastSeenMessage();
        if (lastSeen) {
            var rows = this.lineRenderer.renderLastSeenDivider(lastSeen).flush();
            if (rows.length) {
                this.scroll.checkPinBottom(function (pinBottom) {
                    // Insert if the last seen line is rendered
                    var lastSeenLine = this.getLine(lastSeen);
                    var isLastRendered = !!lastSeenLine.length;
                    
                    this.removeLastSeen({silent: isLastRendered});

                    if (isLastRendered) {
                        this.insertAfter(lastSeenLine, rows);
                    }
                    
                    this.scroll.onChange(pinBottom);
                }, this);
            }
        }
    },
    showLastSeen: function () {
        var lastSeen = this.getLastSeenRow();
        if (lastSeen.length) {
            this.removeFocusSeen();
            this.removeBottomSeen();
            this.getLastSeenRow().removeClass('hidden');
            return true;
        }
    },
    removeLastSeen: function (options) {
        options = options || {};
        this.getLastSeenRow().remove();
        if (!options.silent) {
            this.lineRenderer.lastSeenEid = null;
        }
    },
    getLastSeenRow: function () {
        return this.$('.lastSeen');
    },
    
    renderLoadMore: function () {
        this.removeLoadMore();
        if (!this.scroll.isFullyRendered()) {
            this.lineRenderer.renderLoadMore(this.scroll.getFirstRendered());
        }
    },
    removeLoadMore: function () {
        this.$('.loadMore').remove();
    },
    render: function () {
        var batch;
        if (this.model.messages.length) {
            // Render backlog of messages
            batch = this.model.messages.last(this.scroll.batchSize);
            // Filter out before the most recent discontinuity
            if (this.model.discontinuity) {
                batch = _.filter(batch, function (m) {
                    return m.id > this.model.discontinuity.id;
                }, this);
            }
            this.scroll.setFirstRendered(batch[0]);
            this.renderLoadMore();
            this.lineRenderer.renderMessages(batch);
        } else if (this.model.isDeferred()) {
            this.renderLoadMore();
        } else if (this.model.isThread() && !this.model.hasFirstMessage()) {
            this.renderLoadMore();
        }
        
        var rows = this.lineRenderer.flush();
        this.initialAppend(rows);

        if (batch) {
            var batchOptions = this.batchOptions();
            _.each(batch, function (message) {
                this.handleClientTags(message, batchOptions);
            }, this);
            this.processBatched(batchOptions);
        }
        
        this.setRendered();
        
        if (this.model.isDeferred() || this.model.isCacheReset()) {
            this.scroll.loadOrRenderBacklog();
        }
        
        return this;
    },
    setRendered: function () {
        this.model.messages.bind('add', this.handleMessage, this);
        this.model.bind('sayRequest', this.sayRequest, this);
        this.model.bind('throttleMessage', this.throttleMessage, this);
        this.model.bind('retryPending', this.unmarkErrorPendingRow, this);
        this.model.bind('rewriteSayRequest', this.rewriteSayRequest, this);
        this.model.bind('addErrorUpload', this.addErrorUpload, this);
        this.model.bind('sayError', this.sayError, this);
        this.listenTo(this.model.connection, 'ignoresChange', this.ignoresChange);
        this.listenTo(this.model.connection, 'reload', this.checkFlush);
    },
    
    ignoresChange: function () {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$('.row').each(_.bind(function (i, row) {
                var r = $(row);
                var message = this.scroll.getMessageForRow(r);
                if (message) {
                    r.toggleClass('ignored', message.isIgnored());
                }
            }, this));
            
            this.scroll.onChange(pinBottom);
        }, this);
    },
    batchAppend: function (els) {
        this.prepareEmbeds(els);
        $(this.el).append(els);
        return els;
    },
    initialAppend: function (rows) {
        var els = this.prepareInsertion(rows, null, true);
        $(this.el).append(els);
        this.initialPostInsertion(els);
        return els;
    },
    initialPrepend: function (rows) {
        var els = this.prepareInsertion(rows, null, true);
        $(this.el).prepend(els);
        this.initialPostInsertion(els);
        return els;
    },
    prepend: function (rows, classNames) {
        var els = this.prepareInsertion(rows, classNames);
        $(this.el).prepend(els);
        this.postInsertion(els);
        return els;
    },
    insertAfter: function (target, rows, classNames) {
        var els = this.prepareInsertion(rows, classNames);
        target.after(els);
        this.postInsertion(els);
        return this;
    },
    initialPostInsertion: function (els) {
        if (this.isRendered()) {
            this.postInsertion(els, true);
        } else {
            this.model.once('afterShow', _.bind(function () {
                this.initialPostInsertion(els);
            }, this));
        }
    }
});


module.exports = BufferLogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlogview.js
// module id = KgJn
// module chunks = 1